/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { datasetImportOperationStatusColors } from '../constants/datasetImportOperationStatusColors';
import { DatasetImportOperationStatus } from '../types/dataset/DatasetImportOperationStatus';

export const getDSImportOperationStatusColor = (status: DatasetImportOperationStatus): string => {
  return datasetImportOperationStatusColors[status] || datasetImportOperationStatusColors.__fallback;
};
